/**
 * @description
 */

import './miniProgramBar.scss';

import React, { useState, useEffect, useRef } from 'react';
import { getQueryString } from '@umu/umu-dom';
import { sessionStorageHelper } from '@umu/umu-storage';
import { fetch } from '@umu/umu-fetch';

import { isInMiniProgram, isFromLive } from '../../../@utils';

export default function MiniProgramBar() {
    // const [groupId, setGroupId] = useState('');
    const [isShow, setIsShow] = useState(false);

    const groupId = useRef('');
    const isClicked = useRef(false);

    // 将 groupId 暂存，用于页面跳转后携带状态
    useEffect(() => {
        const param = getQueryString('groupId') || sessionStorageHelper.get('_live_groupId') || '';
        if (param) {
            sessionStorageHelper.set('_live_groupId', param); // 存储一次，跳转页面时会用到
            groupId.current = param;
        }

        if (window.location.href && window.location.href.indexOf && window.location.href.indexOf('debugger=1') > 0) {
            console.warn('当前url: %s', window.location.href);
        }
    }, []);

    // 页面加载后控制展示
    useEffect(() => {
        isInMiniProgram((is) => {
            setIsShow(isFromLive() && is);
        });
    }, []);

    // 通过消息发送到同账号的小程序
    const pushMsgToMiniapp = () => {
        if (isClicked.current) {
            return;
        }
        isClicked.current = true;
        const body = JSON.stringify({
            type: 3,
            module_data: {
                action: 'CLOSE_WEBVIEW',
            },
        });
        fetch
            .post('/uapi/v1/live/push-msg-to-user', {
                parent_id: groupId.current,
                parent_type: 2, // group
                body,
            })
            .then((result: any) => {
                console.warn('/uapi/v1/live/push-msg-to-user 关闭当前页 %o', result);
                isClicked.current = false;
            }, 'json');
    };

    const backMiniProgram = () => {
        pushMsgToMiniapp();
    };

    const render = () => {
        if (!isShow) {
            return null;
        }

        return (
            <div className="mini-program-bar">
                <div className="doc-fixed top bordered">
                    <div className="mini-app-bar" onClick={backMiniProgram}>
                        返回直播
                    </div>
                </div>
                <div className="mini-app-plachholder"></div>
            </div>
        );
    };

    return render();
}
